import DOMPurify from 'dompurify';
import { cn } from '@/lib/utils';

const ALLOWED = { ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'ul', 'ol', 'li', 'a', 'blockquote', 'code', 'pre'], ALLOWED_ATTR: ['href', 'target', 'rel'] };

// Renders a message body: HTML (DOMPurify-sanitised, defence in depth over server nh3) or plain text.
export const RichBody = ({ body, format, className, testId }) => (format === 'html' ? (
  <div className={cn('comms-prose text-sm break-words', className)} data-testid={testId}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body || '', ALLOWED) }} />
) : (
  <p className={cn('text-sm whitespace-pre-wrap break-words', className)} data-testid={testId}>{body}</p>
));
